import React from 'react';

const BrandsCarousel = () => {
  const brands = [
    { name: 'MANN FILTER', logo: '/images/autoparts_markenhaendler_mann.jpg' },
    { name: 'KYB', logo: '/images/autoparts_markenhaendler_kyb.jpg' },
    { name: 'Eibach', logo: '/images/autoparts_markenhaendler_eibach.jpg' },
    { name: 'BILSTEIN', logo: '/images/autoparts_markenhaendler_billstein.jpg' },
    { name: 'Zimmermann', logo: '/images/autoparts_markenhaendler_zimmermann.jpg' },
  ];

  // Дублируем бренды для бесконечной прокрутки
  const duplicatedBrands = [...brands, ...brands, ...brands];

  return (
    <div className="py-6 md:py-8 lg:py-12">
      <div className="overflow-hidden w-full">
        <div className="flex animate-scroll">
          {duplicatedBrands.map((brand, index) => (
            <div
              key={index}
              className="flex-shrink-0 mx-4 md:mx-6 lg:mx-8 flex items-center justify-center"
            >
              <img
                src={brand.logo}
                alt={brand.name}
                className="h-8 md:h-10 lg:h-12 w-auto object-contain opacity-60 hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </div>
      </div>
      <hr className="border-gray-200 mt-6 md:mt-8 lg:mt-12"/>
    </div>
  );
};

export default BrandsCarousel;
